var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedMasterSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/speed-master-silver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.00261627907 6.95652174e-05 44.6537791 6.95652174e-05 44.6537791 48 0.00261627907 48"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-743.000000, -393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/speed-master-silver",
    transform: "translate(743.000000, 393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3281977,48.0000696 L22.3281977,48.0000696 C9.99819767,48.0000696 0.00261627907,38.0334609 0.00261627907,25.7392 L0.00261627907,4.17398261 C0.00261627907,1.86893913 1.8769186,6.95652174e-05 4.18866279,6.95652174e-05 L40.4677326,6.95652174e-05 C42.7794767,6.95652174e-05 44.6537791,1.86893913 44.6537791,4.17398261 L44.6537791,25.7392 C44.6537791,38.0334609 34.6581977,48.0000696 22.3281977,48.0000696",
    id: "Fill-10",
    fill: "#8E9FA8",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.3281977,44.5218087 L22.3281977,44.5218087 C9.99819767,44.5218087 0.00261627907,34.5552 0.00261627907,22.2609391 L0.00261627907,4.17398261 C0.00261627907,1.86893913 1.8769186,6.95652174e-05 4.18866279,6.95652174e-05 L40.4677326,6.95652174e-05 C42.7794767,6.95652174e-05 44.6537791,1.86893913 44.6537791,4.17398261 L44.6537791,22.2609391 C44.6537791,34.5552 34.6581977,44.5218087 22.3281977,44.5218087",
    id: "Fill-13",
    fill: "#D6E4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.467907,6.95652174e-05 L4.18883721,6.95652174e-05 C1.87709302,6.95652174e-05 0.00279069767,1.86893913 0.00279069767,4.17398261 L0.00279069767,22.2609391 C0.00279069767,34.5552 9.99802326,44.5218087 22.3283721,44.5218087 L22.3283721,44.5218087 C34.6583721,44.5218087 44.6539535,34.5552 44.6539535,22.2609391 L44.6539535,4.17398261 C44.6539535,1.86893913 42.7796512,6.95652174e-05 40.467907,6.95652174e-05 M40.467907,4.17398261 L40.467907,22.2609391 C40.467907,32.2341565 32.3305814,40.3478957 22.3283721,40.3478957 C12.3261628,40.3478957 4.18883721,32.2341565 4.18883721,22.2609391 L4.18883721,4.17398261 L40.467907,4.17398261",
    id: "Fill-15",
    fill: "#B6C4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8564651,9.96932174 L15.8564651,23.2465391 C15.8564651,23.6305391 16.1690233,23.9421913 16.5541395,23.9421913 L19.1707674,23.9421913 C19.5562326,23.9421913 19.8684419,24.2534957 19.8684419,24.6378435 L19.8684419,33.3703652 C19.8684419,34.0806261 20.8103023,34.3345391 21.168907,33.7209739 L28.6179767,20.9877565 C28.8893721,20.5241043 28.5541395,19.9414957 28.0155349,19.9414957 L25.0096047,19.9414957 C24.4908837,19.9414957 24.1535581,19.3974957 24.3855349,18.934887 L28.7254186,10.2806261 C28.9573953,9.81801739 28.6200698,9.27366957 28.1013488,9.27366957 L16.5541395,9.27366957 C16.1690233,9.27366957 15.8564651,9.58532174 15.8564651,9.96932174",
    id: "Fill-26",
    fill: "#8E9FA8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedMasterSilver);
export default __webpack_public_path__ + "static/media/speed-master-silver.431406433c02847142ebf67bfbc353a4.svg";
export { ForwardRef as ReactComponent };